import React, { useEffect, useState } from "react";
import { Select_, Row, Col, Form, Button, SuccessNotification } from "components/common";
import { Wrapper } from "./StatusModal.styled";
import { callDeleteApi } from "utils/api";

const StatusModal = ({ dataSource, deleteId, callGetStatusApi, setConfirm }) => {
    const [statusId, setStatusId] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const deleteStatus = () => {
        setIsLoading(true);
        callDeleteApi(
            `/appointment/${deleteId}/${statusId}`,
            () => {
                SuccessNotification("Status Deleted");
                setConfirm(false);
                setIsLoading(false);
                callGetStatusApi();
            },
            (err) => {
                setIsLoading(false);
                console.log(err);
            }
        );
    };

    useEffect(() => {
        if (deleteId) {
            setStatusId(deleteId);
        }
    }, [deleteId]);

    return (
        <Wrapper>
            <Form>
                <Row gutter={[10, 10]}>
                    <Col span={24}>
                        <Select_
                            placeholder="Statuses"
                            options={dataSource.map((e) => ({ name: e.name, id: e._id }))}
                            name
                            value={statusId}
                            onChange={(e) => {
                                setStatusId(e);
                            }}
                        />
                    </Col>
                    <Col span={24} style={{ display: "flex", justifyContent: "flex-end" }}>
                        {" "}
                        <Button title="Submit" className="btn-background" onClick={deleteStatus} loading={isLoading} />
                    </Col>
                </Row>
            </Form>
        </Wrapper>
    );
};

export default StatusModal;
